<template>
  <multiselect 
    placeholder="Select Depot"
    :options="depots.data" 
    label="name" 
    track-by="id" 
    :value="selected" 
    @search-change="handleSearch"
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>{{ props.option.name }}</div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'DepotSelect',

  components: {
    Multiselect
  },

  created () {
    this.getDepots()
  },

  props: ['value'],

  computed: {
    selected () {
      return this.depots.data.find(vehicle => vehicle.id === this.value)
    }
  },

  data () {
    return {
      depots: {
        data: []
      }
    }
  },

  methods: {
    async getDepots (query) {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/depots`, {
          params: {
            search: query
          }
        })
        this.depots = data.depots
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleSearch (query) {
      this.getDepots(query)
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>